import { useLayoutEffect, useState } from 'react';

import { WindowSizeType } from './useWindowSize.types';

const useWindowSize = () => {
  const [size, setSize] = useState<WindowSizeType>({ width: 0, height: 0 });

  useLayoutEffect(() => {
    function updateSize() {
      setSize({ width: window.innerWidth, height: window.innerHeight });
    }
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, []);

  return size;
};

export default useWindowSize;
